<div class="tracker-position" [ngClass]="{'floating-window': !isDialog}">
  <div>
    <div class="header">
      <h3 class="title">
        <mat-icon fontIcon="gps_fixed"></mat-icon>
        {{ 'units.tracker_pos.title' | translate }}
      </h3>

      <!-- <lib-button (click)="dialogRef.close()" icon="close" color="outline"></lib-button> -->
    </div>

    <form class="form">
      <div class="select-div">
        <mat-form-field class="select" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{'units.tracker_pos.choose'|translate}} </mat-label>

          <mat-select [(value)]="trackerIdValue" name="project" (selectionChange)="getPosFromTracker($event)">
            <mat-option *ngFor="let tracker of trackers" [value]="tracker.id" class="tracker-option"
              [ngClass]="{'active': (tracker.id == trackerId())}">{{tracker.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <lib-button *ngIf="lastPositions()[trackerId()]" (click)="getPosFromTracker()" color="none"
          textColor="secondary" title="{{ 'form.retry' | translate }}" class="menu-btn refresh"
          [disabled]="status() == 'loading'" icon="refresh">
        </lib-button>
      </div>

      <div class="coordinates">
        <h4 class="title">
          <mat-icon fontIcon="location_on"></mat-icon>
          {{ 'units.tracker_pos.coords' | translate }}
        </h4>

        <div class="latlon">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Longitude</mat-label>

            <input matInput type="number" [(ngModel)]="lastPositionValue.lon" name="lastlon" required
              (change)="locationChange($event)" />
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Latitude</mat-label>

            <input matInput type="number" [(ngModel)]="lastPositionValue.lat" name="lastlat" required
              (change)="locationChange($event)" />
          </mat-form-field>
        </div>

        <div class="xyz">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>X</mat-label>

            <input matInput type="number" [(ngModel)]="lastPositionValue.x" name="lastx" required />
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Y</mat-label>

            <input matInput type="number" [(ngModel)]="lastPositionValue.y" name="lasty" required />
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Z (alt.)</mat-label>

            <input matInput type="number" [(ngModel)]="lastPositionValue.z" name="lastz" required />
          </mat-form-field>
        </div>
      </div>

      <div *ngIf="showMessage()" class="status">
        <app-progress-loading *ngIf="status() == 'loading'" [duration]="duration"
          [hasData]="trackerPosition().length > 0" [reset]="resetLoading()">
        </app-progress-loading>

        <div class="message">
          <div>
            <mat-icon *ngIf="status() == 'ok'" class="success" fontIcon="location_on"></mat-icon>
            <mat-icon *ngIf="status() == 'error'" class="danger" fontIcon="location_off"></mat-icon>
            <mat-icon *ngIf="status() == 'retry'" class="danger"
              fontIcon="signal_cellular_connected_no_internet_4_bar"></mat-icon>
            {{ messageDisplayed() }}
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="btn-group">
    <lib-button (click)="handleClose()" text="{{ (isDialog() ? 'form.cancel' : 'form.close') | translate }}"
      color="outline" icon="close">
    </lib-button>

    <lib-button (click)="handleSubmit()" text="{{'form.submit' | translate}}" color="primary" icon="save">
    </lib-button>
  </div>
</div>